import Stopwatch from "./components/Stopwatch";
import GlobalStyle from './styles/GlobalStyles'

export default function App() {
  return (
    <>
      <Stopwatch />
      <GlobalStyle />
    </>
  )
}